module.exports = __webpack_public_path__ + "static/media/pointBadgeLevel2Locked.ca2a8196.png";